const accessUserManagement = {

    // User Routes
    USER_LIST: { name: 'User', path: '/user-list' },
    ADD_USER: { name: 'Add User', path: '/add-user' },
    UPDATE_USER: { name: 'Edit User', path: '/edit-user' },
    DELETE_USER: { name: 'Delete User', path: '/delete-user' },


}

export default accessUserManagement;